<div class="container-fluid px-4 position-relative">
  @if (isLoading) {
    <loader [config]="loaderConfig"></loader>
  }
  @if (alertInfo.show) {
    <ngb-alert [type]="alertInfo.type" (closed)="alertInfo.show = false">
      {{ alertInfo.message }}
    </ngb-alert>
  }
  <div class="row w-100 mb-3">
    <proposals-progress-bar [status]="proposal?.status" />
  </div>
  @if (!isScopeChangePage && proposal?.status === 'ACCEPTED') {
    <div class="row w-100 mb-3">
      <proposals-scope-change [proposal]="proposal" />
    </div>
  }
  <div class="row g-3 mb-3">
    <div class="col-md-7">
      <div class="card shadow-sm mb-3">
        <div class="card-header">
          <h3 class="card-title">Generic Data</h3>
          <button type="button" class="btn btn-success ms-auto" (click)="goToViewProposal()" [disabled]="!proposalId">
            View Proposal
          </button>
        </div>
        <div class="card-body row gy-3">
          <proposals-form [readonlyProposalsForm]="true" [allowClientEdit]="isChangeOfScopePage || isScopeChangePage" [proposal]="proposal" #proposalsForm />
          <proposals-data
            [readonlyProposalData]="proposal?.status === 'TECH_APPROVAL' || proposal?.status === 'SALES_OVERALL_CHECK' ? true : readonly "
            [proposal]="proposal" (targetConversionChange)="handleTargetConversionChange($event)" #proposalsData />
        </div>
      </div>
      <proposals-other [proposal]="proposal" [readonlyProposalsForm]="true" #proposalsOther />
    </div>
    <div class="col-md-5">
      <ranking-bar [readonlyRankingBar]="true" [ranking]="proposal?.request?.customer.ranking" [customer]="proposal"
        #rankingBar />
      <proposals-details-form-request [readonlyProposalDetails]="readonly" [proposal]="proposal"
        #proposalsDetailsForm />
      @if (isChangeOfScopePage || isScopeChangePage) {
        <proposals-reason-change-of-scope [readonlyReasonChangeOfScope]="readonly" [proposal]="proposal"
          #proposalsReasonChangeOfScope />
      }

    </div>
    @if (!readonly) {
      <div class="col-12 d-flex justify-content-center">
        <button type="button" class="btn btn-success me-3" (click)="submitAllForms()">
          Save
        </button>
      </div>
    }
  </div>
  @if (this.proposalId != null) {
    <div class="row g-3 mb-2">
      <proposals-items #proposalsItems [readonlyItems]="readonly"
        [verificed]="proposal?.status !== 'TECH_APPROVAL' ? true : false"
        [isOverdiscountApprovalState]="proposal?.status === 'OVERDISCOUNT_APPROVAL'"
        [isTechApprovalState]="proposal?.status === 'TECH_APPROVAL'" [items]="proposalItems"
        [proposalId]="proposal?.proposalId" [isItemsLocked]="isItemsLocked"
        [targetExchangeRate]="targetExchangeRate" [targetCurrencyLabel]="targetCurrencyLabel"
        (verificationChanged)="handleVerificationChange($event)"
        (overdiscountVerificationChanged)="handleOverdiscountVerificationChange($event)"
        (onSavedData)="handleItemChange($event)" (discountWarningChanged)="handleDiscountWarningChange($event)"
        (itemsChangedState)="handleItemsChangedState($event)"
      (techApprovalVerificationChanged)="handleTechApprovalVerificationChanged($event)"></proposals-items>
      <proposals-campaigns [campaigns]="campaigns" />
    </div>
  }
  <div class="row mb-3">
    @if (proposal?.proposalId != null) {
      <div class="col-12 d-flex justify-content-center" >
        @if (proposal?.status === 'SALES') {
          @if (nextStateButtonType === 'overdiscount') {
            <button type="button" class="btn btn-warning me-2"
              (click)="requestOverdiscountApproval()" [disabled]="!allJustificationsProvided || !canActOnCurrentStatus"
              [title]="hasUnsavedChanges ? 'Save modified items first' : (!allJustificationsProvided ? 'Provide justification for all items with high discount' : '')">
              Overdiscount Approval
            </button>
          }
          @if (nextStateButtonType === 'tech') {
            <button type="button" class="btn btn-primary btn-gw2"
              (click)="goToState('TECH_APPROVAL')" [disabled]="hasUnsavedChanges || !canActOnCurrentStatus"
              [title]="hasUnsavedChanges ? 'Save modified items first' : ''">
              Request Technical Approval
            </button>
          }
        }
        @if (proposal?.status === 'OVERDISCOUNT_APPROVAL') {
          <button type="button" class="btn btn-danger me-2" (click)="goToState('SALES')"
            [disabled]="!canActOnCurrentStatus"
            [title]="hasUnsavedChanges ? 'Save modified items first' : ''">
            Reject Overdiscount
          </button>
          <button type="button" class="btn btn-primary btn-gw2" (click)="goToState('TECH_APPROVAL')"
            [disabled]="buttonState !== 'success' || !canActOnCurrentStatus"
            [title]="buttonState !== 'success' ? 'Verify all items with overdiscount' : ''">
            Request Technical Approval
          </button>
        }
        @if (proposal?.status === 'TECH_APPROVAL') {
          <button type="button" class="btn btn-primary btn-gw2 me-2" (click)="goToState('SALES_OVERALL_CHECK')"
            [disabled]="buttonState !== 'success' || !canActOnCurrentStatus" [title]="buttonState !== 'success' ? 'Verify all items' : ''">
            Accept Technical Approval
          </button>
          <button type="button" class="btn btn-danger" (click)="rejectTechnicalApproval(rejectTechApprovalModal)"
            [disabled]="!canActOnCurrentStatus">
            Reject Technical Approval
          </button>
        }
        @if (proposal?.status === 'SALES_OVERALL_CHECK') {
          <button type="button" class="btn btn-primary btn-gw2" (click)="sendToClient()"
            [disabled]="!canActOnCurrentStatus"
            [title]="hasUnsavedChanges ? 'Save modified items first' : ''">
            Send to Client
          </button>
        }
        @if (proposal?.status === 'PENDING_CLIENT') {
          <button type="button" class="btn btn-success me-2" (click)="acceptProposal(confirmProjectModal)"
            [disabled]="!canActOnCurrentStatus"
            [title]="hasUnsavedChanges ? 'Save modified items first' : ''">
            Accept
          </button>
          <button type="button" class="btn btn-danger" (click)="rejectProposal()"
            [disabled]="!canActOnCurrentStatus"
            [title]="hasUnsavedChanges ? 'Save modified items first' : ''">
            Reject
          </button>
        }
        @if ((proposal?.status === 'ACCEPTED' || proposal?.status === 'NOT_ACCEPTED')  && proposal?.accepted === true) {
          <button type="button" class="btn btn-primary btn-gw2" (click)="goToProject()">
            Go to Project
          </button>
        }
      </div>
    }
  </div>
  <div class="row g-3">
    <div class="col-sm-8">
      <notes-customers-form [readonlyCustomerNotes]="readonly" [customer]="proposalNotes"
        [noteServiceMethod]="proposalsService" [addNoteMethod]="'createNotes'" [deleteNoteMethod]="'deleteNotes'"
        [sectionAttribute]="'proposalId'" />
    </div>
    <div class="col-sm-4 mt-3">
      <div class="card shadow-sm mb-3">
        <div class="card-header">
          <h3 class="card-title">Proposal Archive</h3>
        </div>
        <div class="card-body">
          <proposals-attachments-panel [proposal]="proposal" [attachments]="proposal?.contractAttachments" [readonlyAttachmentsPanel]="true" />
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #confirmProjectModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Confirm Acceptance</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p>Are you sure you want to accept this proposal? A project will be automatically created by the system.</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-success" (click)="modal.close('confirm')">Confirm</button>
  </div>
</ng-template>

<ng-template #rejectTechApprovalModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Reject Technical Approval</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
  </div>
  <div class="modal-body">
    <p class="mb-3">Please add a comment explaining why you are rejecting the technical approval:</p>
    <textarea-field
      [textareaFormControl]="rejectCommentControl"
      placeholder="Enter your comment..."
      [readonly]="false"
      [height]="150">
    </textarea-field>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button type="button" class="btn btn-danger" (click)="modal.close('confirm')">Send</button>
  </div>
</ng-template>